<template>
  <div
    :class="{'agents-bar--with-side-menu': menuOpened}"
    class="agents-bar"
  >
    <span
      v-if="agent"
      class="agents-bar__title"
    >
      {{ $t('comps.AgentsBar.agent', [agent.desage]) }}
    </span>
    <SingleButton
      :height="30"
      icon="cancel"
      appearance="agent"
      @click="handleCancel"
    >
      {{ $t('comps.AgentsBar.cancel') }}
    </SingleButton>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useRootStore } from '@/stores/root';
import SingleButton from '@/components/buttons/SingleButton.vue';

export default {
  name: 'AgentsBar',
  components: {
    SingleButton,
  },
  computed: {
    // Vuex mapGetters → Pinia rootStore.
    ...mapState(useRootStore, ['menuOpened', 'agent']),
  },
  methods: {
    ...mapActions(useRootStore, ['setAgent']),
    handleCancel() {
      this.setAgent(null);
    },
  },
};
</script>
<style lang="scss">
.agents-bar {
    z-index: 24;
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 20px;
    background-color: $red-radical;

    &--with-side-menu {
        @include desktop {
            left: 260px;
        }
    }

    &__title {
        color: $white;
        font-size: $size-9;
    }
}
</style>
